export default [{
        path: '/',
        component: () => import( /* webpackChunkName: "post" */ '../../components/post/post-single.vue'),
        meta: { primaryOnMobile: true, postMobilebar: true }
    },
    {
        path: 'edit/',
        component: () => import( /* webpackChunkName: "post" */ '../../components/post/post-edit.vue')
    },
    {
        path: 'likes/',
        components: {
            default: () => import( /* webpackChunkName: "post" */ '../../components/post/post-single.vue'),
            'dialog': () => import( /* webpackChunkName: "post" */ '../../components/post/post-likes.vue')
        },
        meta: { primaryOnMobile: true, postMobilebar: true }
    },
    {
        path: 'comments/',
        components: {
            default: () => import( /* webpackChunkName: "post" */ '../../components/post/post-comment.vue')
        },
        meta: { noBottombarsMobile: true, primaryOnMobile: true, genericMobilebar: true, noFooters: true }
    },
    {
        path: 'media/:mediaId/',
        component: () => import( /* webpackChunkName: "post" */ '../../components/post/post-single-file.vue'),
        meta: { noBottombarsMobile: true, mediaView: true, noTopbars: true, noFooters: true }
    }
]